import Root from '@/apps/messages/Root.vue';
import Sittercity from './sittercity';
import { setupApollo } from '../lib/apollo_setup';
import { SITTER_DETAILS_FOR_PARENT_QUERY } from '@/graphql/messages/queries';
import { redirect } from '@/helpers/redirects';
import router from '@/router';
import store from '@/store';

// eslint-disable-next-line import/prefer-default-export
export async function sitterDetailsForParent(accountId) {
  const apolloProvider = setupApollo();

  const res = await apolloProvider.defaultClient.query({
    query: SITTER_DETAILS_FOR_PARENT_QUERY,
    variables: { accountId },
  });

  return res.data.account;
}

document.addEventListener('DOMContentLoaded', async () => {
  const apolloProvider = setupApollo();

  const appNode = document.getElementById('app');

  if (appNode == null) {
    throw new Error('App node not found. Aborting.');
  }

  try {
    await store.dispatch('account/fetchAccountData');
  } catch {
    // Error is committed to store by the action; continue so redirect runs when account is null
  }
  const account = store.getters['account/getAccount'];

  if (!account) {
    redirect('/login');
    return;
  }

  store.dispatch('navigation/startPolling');

  new Sittercity({
    name: 'Messages Sendbird Page',
    render(createElement) {
      return createElement(Root);
    },
    router,
    store,
    apolloProvider,
  }).$mount('#app');
});
